/**
 * /app — the universal-link target for the app-handoff magic link.
 *
 * On a phone with the app installed + Universal/App Links configured, the OS
 * opens the APP at this path (this web page never renders). If the app ISN'T
 * installed, the browser lands here: show install options (store badges + QR).
 * The Supabase magic-link token in the URL is harmlessly consumed by the web
 * client (detectSessionInUrl) — the real sign-in happens in the app.
 */

import React from "react";
import appleStoreBadge from "../../images/apple-store.png";
import googlePlayBadge from "../../images/google-play-badge.png";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/sarv-ai-holistic-health-coach/id6759615073";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.m31v1.sarv";

const AppOpen = () => (
  <div style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "100px 20px 40px" }}>
    <div style={{ maxWidth: 420, textAlign: "center" }}>
      <div style={{ fontSize: 22, fontWeight: 300, letterSpacing: 3, color: "#2C3E50", marginBottom: 16 }}>sârv</div>
      <h1 style={{ fontSize: 26, fontWeight: 800, color: "#2C3E50", marginBottom: 8 }}>Open Sârv on your phone</h1>
      <p style={{ color: "#6B7280", lineHeight: 1.5, marginBottom: 24 }}>
        If the app didn't open automatically, install it below and sign in with
        your email — your premium plan is already unlocked.
      </p>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
        <a href={APP_STORE_URL} target="_blank" rel="noreferrer" aria-label="Download on the App Store">
          <img src={appleStoreBadge} alt="Download on the App Store" style={{ height: 52 }} />
        </a>
        <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer" aria-label="Get it on Google Play">
          <img src={googlePlayBadge} alt="Get it on Google Play" style={{ height: 52 }} />
        </a>
      </div>

      <div style={{ marginTop: 28 }}>
        <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.5, color: "#9CA3AF", textTransform: "uppercase", marginBottom: 8 }}>
          On a computer?
        </div>
        <img
          src="/my-applink-qrcode.png"
          alt="Scan to download the Sârv app"
          style={{ width: 160, height: 160, borderRadius: 12, border: "1px solid #E5E7EB" }}
        />
      </div>
    </div>
  </div>
);

export default AppOpen;
